/*
export const config: any = {
    mainUrl: "https://zbotman.com/map/public/",
    apiUrl: "https://zbotman.com/map/public/api/",
    path: '/map/public/',
    assetsUrl: 'https://zbotman.com/map/public/assets/build/assets/'
}
*/

/*export const config: any = {
    mainUrl: "https://listing.abhi.com/",
    apiUrl: "https://listing.abhi.com/api/",
    path: '/',
    assetsUrl: 'https://listing.abhi.com/assets/build/assets/'
}*/

export const config: any = {
    mainUrl: "https://knockit.io/",
    apiUrl: "https://knockit.io/api/",
    path: '/',
    assetsUrl: 'https://knockit.io/assets/build/assets/'
}
